import { API_URL } from '../../util/networkEndpoints';
import newLogo from '../../assets/pknin-logo.png';
import { UserCenter } from './UserCenter';
import { readUserCenterReturn, consumeUserCenterReturn } from '../../util/userCenterSession';
import { LocalizedText } from '../../components/LocalizedText';
import './Landing.css';
import './PortalPolish.css';
import * as React from 'react';
import { Login } from './Login';
import { Register } from './Register';
import { useTranslation } from 'react-i18next';
import outfits from './outfits.json';
import { isMobileGameDevice } from '../../hooks/useMobileGameViewport';

const asset = (path: string) => `${process.env.REACT_APP_CDN_PATH ?? 'assets/'}${path}`;
const news = [
  {
    category: 'News',
    title: 'Welcome to PkNiN',
    text: 'เซิร์ฟเวอร์พร้อมให้เริ่มการผจญภัยแล้ว สมัครบัญชี เลือก Mainland และสร้างตัวละครของคุณ',
    date: '2026-10-18',
  },
  {
    category: 'Notices',
    title: 'Local server is ready',
    text: 'เปิดใช้งานระบบบัญชีและเซิร์ฟเวอร์ Mainland บนเครื่องนี้แล้ว สถานะทางขวาจะอัปเดตทุก 15 วินาที',
    date: '2026-10-18',
  },
  {
    category: 'News',
    title: 'Choose your ninja outfit',
    text: 'ชมตัวอย่างชุดได้จาก Outfit Display แล้วค้นหาชุดตัวละครเพิ่มเติมภายในเกม',
    date: '2026-10-18',
  },
  {
    category: 'Activities',
    title: 'Begin your ninja journey',
    text: 'เริ่มต้นด้วยการสร้างตัวละครและทำภารกิจแนะนำภายในเกม',
    date: '2026-10-18',
  },
  {
    category: 'Notices',
    title: 'Account registration',
    text: 'กด Register เพื่อสมัครบัญชีใหม่ รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร',
    date: '2026-10-18',
  },
  {
    category: 'News',
    title: 'Explore Mainland',
    text: 'เข้าสู่ Mainland เพื่อสำรวจหมู่บ้าน พบตัวละคร และเริ่มภารกิจของคุณ',
    date: '2026-10-18',
  },
];
const slides = [
  { image: 'ad_20260821000000.png', label: "Rewards for Kage's Disciple" },
  { image: 'ad_20260504000000.png', label: 'PkNiN event banner' },
  { image: 'ad_20260403000000.png', label: 'PkNiN adventure banner' },
];

export const Landing: React.FC = () => {
  const { t } = useTranslation();
  const [showLogin, setShowLogin] = React.useState(() => isMobileGameDevice() && !readUserCenterReturn());
  const [authKey, setAuthKey] = React.useState(0);
  const [returnToken,setReturnToken]=React.useState(readUserCenterReturn);
  React.useEffect(()=>{consumeUserCenterReturn();},[]);
  const [loginTarget, setLoginTarget] = React.useState<'home'|'topup'|'mall'>('home');
  const [showRegister, setShowRegister] = React.useState(false);
  const [info, setInfo] = React.useState<{ title: string; body: React.ReactNode } | null>(null);
  const [tab, setTab] = React.useState('All');
  const [slide, setSlide] = React.useState(0);
  const [outfit, setOutfit] = React.useState(0);
  const [status, setStatus] = React.useState<{ online: boolean; playersOnline: number } | null>(null);
  const closeRef = React.useRef<HTMLButtonElement>(null);
  const openInfo = (title: string, body: React.ReactNode) => setInfo({ title, body });
  const guide = () =>
    openInfo(
      'Newbie Guide',
      <ol>
        <li>
          <LocalizedText text={'กด Register เพื่อสร้างบัญชี รหัสผ่านอย่างน้อย 8 ตัวอักษร'} />
        </li>
        <li>
          <LocalizedText text={'กด Game Start แล้วเข้าสู่ระบบ'} />
        </li>
        <li>
          <LocalizedText text={'เลือก Mainland และสร้างตัวละคร'} />
        </li>
        <li>
          <LocalizedText text={'ทำภารกิจเริ่มต้นเพื่อเรียนรู้การเล่น'} />
        </li>
      </ol>
    );
  const shop = () =>
    openInfo(
      'Urahara Shop',
      <p>
        <LocalizedText text={'เข้าสู่เกมเพื่อดูร้านค้าและไอเทมที่มีให้บริการ'} />
      </p>
    );
  const startGame = () => {localStorage.removeItem('jwt');setLoginTarget('home');setShowLogin(true);};

  React.useEffect(() => {
    const controller = new AbortController();
    const refresh = async () => {
      try {
        const response = await fetch(`${API_URL}/status`, { signal: controller.signal });
        if (!response.ok) throw new Error('Status unavailable');
        const data = await response.json();
        if (!controller.signal.aborted) setStatus({ online: data.online === true, playersOnline: Number(data.playersOnline) || 0 });
      } catch {
        if (!controller.signal.aborted) setStatus({ online: false, playersOnline: 0 });
      }
    };
    refresh();
    const interval = window.setInterval(refresh, 15000);
    return () => {
      controller.abort();
      window.clearInterval(interval);
    };
  }, []);
  React.useEffect(() => {
    const timer = window.setInterval(() => setSlide((value) => (value + 1) % slides.length), 3000);
    return () => window.clearInterval(timer);
  }, []);
  React.useEffect(() => {
    if (!info) return;
    const previous = document.activeElement as HTMLElement | null;
    closeRef.current?.focus();
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setInfo(null);
      if (event.key === 'Tab') {
        const dialog = closeRef.current?.closest('[role="dialog"]');
        const controls = Array.from(dialog?.querySelectorAll<HTMLElement>('button, a[href], input, [tabindex="0"]') ?? []);
        const first = controls[0], last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }
    };
    window.addEventListener('keydown', onKey);
    return () => {
      window.removeEventListener('keydown', onKey);
      previous?.focus();
    };
  }, [info]);

  const spriteButton = (label: string, offset: number, action: () => void) => {
    const index = [0, 77, 154, 230, 307].indexOf(offset);
    const top = [20, 350, 642, 934, 1210][index];
    const height = index === 0 ? 330 : 284;
    const clipId = `landing-button-clip-${index}`;
    return (
    <button
      type="button"
      className="landing-menu-button"
      aria-label={label}
      title={label}
      onClick={action}
    >
      <svg viewBox={`20 ${top} 1006 ${height}`} preserveAspectRatio="xMidYMid meet" aria-hidden="true" focusable="false">
        <defs><clipPath id={clipId} clipPathUnits="userSpaceOnUse"><rect x="20" y={top} width="1006" height={height} /></clipPath></defs>
        <image href={asset('site/buttons3.png')} width="1046" height="1504" clipPath={`url(#${clipId})`} />
      </svg>
    </button>
    );
  };
  const current = slides[slide];
  const selectedOutfit = outfits[outfit];
  const outfitName = selectedOutfit.translationKey
    ? t(selectedOutfit.translationKey, { defaultValue: selectedOutfit.name })
    : selectedOutfit.name;

  return (
    <div className="landing">
      <div className="landing-background" aria-hidden="true" style={{ backgroundImage: `url(${asset('site/body.jpg')})` }} />
      <section className="landing-masthead" id="landing-home" aria-label="PkNiN">
        <div className="landing-masthead-copy">
          <img className="landing-logo" src={newLogo} alt="PkNiN" />
          <p>ตำนานนินจาบทใหม่ เริ่มต้นที่นี่</p>
          <span className="landing-realm">
            <i className={status?.online ? 'online' : ''} /> MAINLAND ·{' '}
            {status === null ? 'กำลังตรวจสอบเซิร์ฟเวอร์' : status.online ? 'พร้อมให้บริการ' : 'เซิร์ฟเวอร์ออฟไลน์'}
          </span>
        </div>
        <img className="landing-rivals" src={asset('site/branding/naruto-sasuke-rivals.png')} alt="Naruto และ Sasuke" />
        <div className="landing-masthead-caption">
          <span>YOUR NINJA WAY</span>
          <strong>
            เลือกเส้นทาง
            <br />
            สร้างตำนานของคุณ
          </strong>
        </div>
      </section>
      <main className="landing-layout">
        <aside className="landing-left">
          <button
            type="button"
            className="start-button"
            aria-label="Game Start"
            onClick={startGame}
          ><img src={asset('site/ปุ่มเริ่มเกมส์ธีมใบไม้สดใส.png')} alt="" draggable={false} /></button>
          <nav className="landing-primary" aria-label="Account menu">
            {spriteButton('Register', 0, () => setShowRegister(true))}
            {spriteButton('Charge', 77, () => { setLoginTarget('topup'); setShowLogin(true); })}
          </nav>
          <div className="landing-sidebar-panel">
            <button
              type="button"
              className="landing-gift"
              aria-label="Claim Giftbox"
              title="Claim Giftbox"
              onClick={() =>
                openInfo(
                  'Claim Giftbox',
                  <p>
                    <LocalizedText text={'ยังไม่มีกิจกรรมรับ Giftbox เปิดให้บริการ ติดตามประกาศได้จากหน้า News'} />
                  </p>
                )
              }
            />
            <button type="button" className="landing-shop-link" aria-label="Urahara Shop" title="Urahara Shop" onClick={shop} />
            <section className="landing-outfits">
              <h2>
                <LocalizedText text={'Outfit Display'} />
              </h2>
              <div className="outfit-stage">
                <button
                  type="button"
                  aria-label="Previous outfit"
                  onClick={() => setOutfit((outfit + outfits.length - 1) % outfits.length)}>
                  ‹
                </button>
                <img key={selectedOutfit.file} src={asset(`poses/${selectedOutfit.file}`)} alt={outfitName} />
                <button type="button" aria-label="Next outfit" onClick={() => setOutfit((outfit + 1) % outfits.length)}>
                  ›
                </button>
              </div>
              <p aria-live="polite">
                <LocalizedText text={outfitName} />
              </p>
            </section>
            <div className="landing-community" aria-hidden="true" />
            <section className="landing-fans">
              <h2>
                <LocalizedText text={'Facebook Fans'} />
              </h2>
              <div className="landing-facebook-box">
                <iframe
                  title="PkNiN Facebook Page"
                  src={`https://www.facebook.com/plugins/page.php?${new URLSearchParams({
                    href: 'https://www.facebook.com/pknjth/',
                    tabs: '',
                    width: '240',
                    height: '160',
                    small_header: 'false',
                    adapt_container_width: 'true',
                    hide_cover: 'false',
                    show_facepile: 'true',
                  }).toString()}`}
                  width="240"
                  height="160"
                  loading="lazy"
                  allow="encrypted-media; picture-in-picture; web-share"
                />
              </div>
              <a className="landing-facebook-link" href="https://www.facebook.com/pknjth/" target="_blank" rel="noopener noreferrer">
                <LocalizedText text={'เปิดเพจ PkNiN ↗'} />
              </a>
            </section>
          </div>
        </aside>

        <section className="landing-center" id="landing-news" aria-label="News and events">
          <div className="landing-banner-frame">
            <div className="banner-dots" aria-label="Select banner">
              {slides.map((_, index) => (
                <button
                  key={index}
                  type="button"
                  aria-label={`Banner ${index + 1}`}
                  aria-pressed={slide === index}
                  onClick={() => setSlide(index)}
                />
              ))}
            </div>
            <button
              type="button"
              className="landing-banner"
              onClick={() =>
                openInfo(
                  'PkNiN',
                  <p>
                    <LocalizedText text={'ภาพประชาสัมพันธ์จากเว็บอ้างอิง กิจกรรมและรางวัลในภาพยังไม่ได้เปิดใช้งานบนเซิร์ฟเวอร์นี้'} />
                  </p>
                )
              }>
              <img src={`/landing/${current.image}`} alt={current.label} />
            </button>
          </div>
          <section className="landing-news">
            <div className="news-tabs" role="tablist" aria-label="News categories">
              {['All', 'News', 'Notices', 'Activities'].map((item) => (
                <button
                  type="button"
                  key={item}
                  role="tab"
                  id={`news-tab-${item}`}
                  aria-controls="news-list"
                  aria-selected={tab === item}
                  onClick={() => setTab(item)}>
                  <LocalizedText text={item} />
                </button>
              ))}
            </div>
            <div className="news-list" id="news-list" role="tabpanel" aria-labelledby={`news-tab-${tab}`}>
              {news
                .filter((item) => tab === 'All' || item.category === tab)
                .map((item) => (
                  <button
                    type="button"
                    className="news-row"
                    key={item.title}
                    onClick={() =>
                      openInfo(
                        item.title,
                        <>
                          <p>
                            <LocalizedText text={item.text} />
                          </p>
                          <small>
                            <LocalizedText text={item.date} />
                          </small>
                        </>
                      )
                    }>
                    <span className={`news-badge badge-${item.category.toLowerCase()}`}>
                      <LocalizedText text={item.category} />
                    </span>
                    <span className="news-title">
                      <LocalizedText text={item.title} />
                    </span>
                    <time dateTime={item.date}>
                      <LocalizedText text={item.date} />
                    </time>
                  </button>
                ))}
            </div>
          </section>
        </section>

        <aside className="landing-right">
          <nav className="landing-quick-links" aria-label="Help and shop">
            {spriteButton('Newbie Guide', 154, guide)}
            {spriteButton('Urahara Shop', 230, () => {setLoginTarget('mall');setShowLogin(true);})}
            {spriteButton('Live Support', 307, () =>
              openInfo(
                'Live Support',
                <p>
                  <a href="https://www.facebook.com/pknjth/" target="_blank" rel="noopener noreferrer">ติดต่อทีมงานผ่านเพจ PkNiN ↗</a>
                </p>
              )
            )}
          </nav>
          <section className="landing-status" aria-label="Server status">
            <dl>
              <dt>
                <LocalizedText text={'Server Status:'} />
              </dt>
              <dd className={status?.online ? 'status-online' : 'status-offline'}>
                <LocalizedText text={status === null ? 'Checking…' : status.online ? 'Online' : 'Offline'} />
              </dd>
              <dt>
                <LocalizedText text={'Players Online:'} />
              </dt>
              <dd>{status?.online ? status.playersOnline : '—'}</dd>
            </dl>
            <a className="landing-apk-download" href="/download" aria-label="ดาวน์โหลด PKNiN APK สำหรับ Android">
              <img src="/assets/site/download-apk.png" alt="ดาวน์โหลด APK Beta 1" width="2148" height="732" loading="lazy" />
            </a>
          </section>
        </aside>
      </main>
      {returnToken&&<UserCenter jwt={returnToken} onClose={()=>{setReturnToken(undefined);setShowLogin(isMobileGameDevice());}}/>}
      {showLogin && <Login key={authKey} initialTab={loginTarget} onRegister={() => {setShowLogin(false);setShowRegister(true);}} onClose={() => { setAuthKey(value=>value+1); setShowLogin(isMobileGameDevice()); setLoginTarget('home'); }} />}
      {showRegister && <Register onLogin={() => {setShowRegister(false);setShowLogin(true);}} onClose={() => {setShowRegister(false);if(isMobileGameDevice())setShowLogin(true);}} />}
      {info && (
        <div className="landing-info-backdrop" onClick={() => setInfo(null)}>
          <section
            className="landing-info"
            role="dialog"
            aria-modal="true"
            aria-labelledby="landing-info-title"
            onClick={(event) => event.stopPropagation()}>
            <button type="button" ref={closeRef} className="landing-info-close" aria-label="Close" onClick={() => setInfo(null)}>
              ×
            </button>
            <img className="landing-info-emblem" src={newLogo} alt="PkNiN" />
            <span className="landing-info-kicker">PkNiN · บันทึกจากหมู่บ้าน</span>
            <h2 id="landing-info-title">
              <LocalizedText text={info.title} />
            </h2>
            <div className="landing-info-content">{info.body}</div>
            <button type="button" className="landing-info-confirm" onClick={() => setInfo(null)}>รับทราบ <span aria-hidden="true">✦</span></button>
          </section>
        </div>
      )}
    </div>
  );
};
